export enum BadgeState {
    ERROR = 'error',
    INACTIVE = 'inactive',
    INFO = 'info',
    READY = 'ready',
    REVIEW = 'review',
    VALID = 'valid',
    WARNING = 'warning',
}
